export default (ctx, key) => {
  let strings = {
    //login and login-verification
    "wrong_entries": "Wrong Credentials!",
    "wrong_sms_code": "Incorrect code! please try again",
    //reset password
    "email_sent": "We sent you an email with instructions on how to continue resetting your password.",
    "email_not_found": "Email you've entered is not used for a user",
    "password_reset": "Password changed successfully! Please login",
    "something_went_wrong": "Something Went Wrong!",
    "sms_resent": "Another SMS was sent to your phone",
    "email_resent": "Another Email was sent",
    "invalid_phonenumber": 'Invalid Phone Number'
  }
  return strings[key]
}
  